import React from 'react';
import { ShieldCheck, ShieldAlert, ShieldQuestion, Shield } from 'lucide-react';

/**
 * Certification badge for measures and models.
 * Small, self-contained, reused across MetadataTableView, ModelHeader,
 * AI Explore answers and the Certification Queue.
 *
 * Props:
 *   status: 'certified' | 'in_review' | 'draft' | 'rejected' | 'deprecated' | undefined
 *   size: 'xs' | 'sm' (default 'sm')
 *   replacedBy: string (only for deprecated — shown as tooltip)
 */
const META = {
  certified:  { label: 'Certified',    Icon: ShieldCheck,     cls: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30' },
  in_review:  { label: 'In review',    Icon: ShieldQuestion,  cls: 'bg-amber-500/15 text-amber-300 border-amber-500/30' },
  rejected:   { label: 'Rejected',     Icon: ShieldAlert,     cls: 'bg-rose-500/15 text-rose-300 border-rose-500/30' },
  deprecated: { label: 'Deprecated',   Icon: ShieldAlert,     cls: 'bg-rose-600/20 text-rose-200 border-rose-500/40' },
  draft:      { label: 'Uncertified',  Icon: Shield,          cls: 'bg-zinc-500/15 text-zinc-300 border-zinc-500/30' },
};

export function CertificationBadge({ status = 'draft', size = 'sm', replacedBy, className = '', testId }) {
  const meta = META[status] || META.draft;
  const Icon = meta.Icon;
  const dims = size === 'xs'
    ? 'text-[9px] px-1.5 py-0.5 gap-1 [&_svg]:w-2.5 [&_svg]:h-2.5'
    : 'text-[10px] px-1.5 py-0.5 gap-1 [&_svg]:w-3 [&_svg]:h-3';
  const title = status === 'deprecated' && replacedBy
    ? `Deprecated — use ${replacedBy} instead`
    : meta.label;
  return (
    <span
      className={`inline-flex items-center rounded-md border font-medium ${meta.cls} ${dims} ${className}`}
      title={title}
      data-testid={testId || `cert-badge-${status}`}
    >
      <Icon />
      {meta.label}
    </span>
  );
}

export default CertificationBadge;
